<template>
  <div class="about">
    <van-sticky>
      <van-nav-bar title="隐私政策" :border="false" left-arrow @click-left="goBack">

      </van-nav-bar>
    </van-sticky>

    <div style="font-size: 12px;color:#687a94;padding: 10px 15px">
      <div class="wcc-content">本隐私政策发布并生效于 2025年11月7日</div>
      <div class="wcc-content"></div>
      <div class="wcc-content">“网查查”是由成都洞见科技有限公司（以下简称“本公司”）为您提供移动网络和WIFI网络测速和网络检测诊断服务的工具应用。</div>
      <div class="wcc-content">我们非常重视您的个人信息和隐私保护，我们将会按照法律要求和业界成熟的安全标准，为您的个人信息提供相应的安全保护措施。本隐私政策适用于“网查查”基于本客户端所提供的服务，请您在使用本客户端服务前，仔细阅读并了解本隐私政策。</div>
      <div class="wcc-content">→ 我们为您提供移动网络和WIFI网络的网络测速和网络检测诊断服务。</div>
      <div class="wcc-content">→ 当您使用我们的网络测速或网络检测与检测诊断服务时，我们会收集和处理您的位置数据和终端信息用于网络测速和检测诊断（包括网络信息、基站ID、上传下载速率等网络指标）。</div>
      <div class="wcc-content">→ 我们会将网络测速或检测诊断结果经过统计处理后共享给电信运营商，用于通信网络质量的改善和手机功能的优化。</div>
      <div class="wcc-content"></div>
      <div class="wcc-content">1. 我们如何收集和使用您的个人信息</div>
      <div class="wcc-content">您可以使用“网查查”的测速功能来测试运营商移动网络、WIFI宽带网络的上传、下载速率以及网络的时延，抖动等性能指标，并生成测速历史记录。检测诊断功能来呈现并分析网络状态、数据状态和手机状态来诊断当前您的上网故障问题，并给出初步的处理建议。</div>
      <div class="wcc-content">为此我们需要收集您的如下信息：</div>
      <div class="wcc-content">1.1位置信息：</div>
      <div class="wcc-content">目的：</div>
      <div class="wcc-content">→ 界面呈现。（应用内的：测速工具、提速工具、网络哪家好、手机信号工具）</div>
      <div class="wcc-content">→ 测速功能的原理是在服务器和手机之间进行最大速率的数据传输，要求匹配较近的测速服务器。</div>
      <div class="wcc-content">→ 不满足较近时，例如这个场景：在上海测速，匹配西安的服务器，测速的结果则不可靠。故需要匹配接近的测速节点服务器，以保证测速结果的准确性。</div>
      <div class="wcc-content">→ 在诊断服务中，使用户能够直观的定位故障诊断的地点，并可在地图上调整自己的实际位置，以便能够更加准确定位你附近的无线基站信息。</div>
      <div class="wcc-content">1.2手机状态：</div>
      <div class="wcc-content">目的：</div>
      <div class="wcc-content">→界面呈现：（应用内的：测速工具、WIFI分析工具、手机信号工具、网络哪家好功能）</div>
      <div class="wcc-content">1.3WIFI状态：</div>
      <div class="wcc-content">目的：</div>
      <div class="wcc-content">→界面呈现：（应用内的：WIFI分析工具、网络哪家好功能）</div>
      <div class="wcc-content">1.4加速度传感器</div>
      <div class="wcc-content">目的：</div>
      <div class="wcc-content">→ 为用户呈现海拔高度参数。本参数的需要获取加速度传感器，通过一个算法计算出用户的海拔高度。（应用内的：手机信号工具）</div>
      <div class="wcc-content">→ 当用户手机没有加速度传感器时，应用内不提供海拔数据。</div>
      <div class="wcc-content">1.5设备信息：</div>
      <div class="wcc-content">目的：</div>
      <div class="wcc-content">→ 界面呈现终端型号、终端系统、接入无线基站小区ID、 网络信息和诊断结果等信息。（手机信号工具）</div>
      <div class="wcc-content">→ 界面呈现MAC地址、WIFI网络信息和诊断结果等信息。（wifi分析工具）</div>
      <div class="wcc-content">→ 集成的极光SDK一键登录，需收集IMSI、IMEI、设备序列号。可参考本协议中极光SDK隐私协议链接查看。</div>
      <div class="wcc-content">→ 界面呈现基站信息，如TAC/PCI/CI/经度/维度/海拔（海拔要求用户手机支持，某些型号不支持）并且提交给高德地图的API，最终通过经纬度输出为一个地址，呈现给用户查看</div>
      <div class="wcc-content">1.6,ANDROID ID</div>
      <div class="wcc-content">目的：</div>
      <div class="wcc-content">→ 脱敏地标识出唯一用户。</div>
      <div class="wcc-content">1.7打电话：</div>
      <div class="wcc-content">目的：</div>
      <div class="wcc-content">→ 在用户查出网络有问题的时候，提供快捷的拨打10000（电信）、10086（移动）、10010（联通）客服热线（自动匹配）的功能。</div>
      <div class="wcc-content"></div>
      <div class="wcc-content">本公司收集您的上述个人数据进行脱敏后的统计分析，同时用于以下目的：</div>
      <div class="wcc-content">→ 运营商网络质量评测</div>
      <div class="wcc-content">→ 内网网络质量评测</div>
      <div class="wcc-content">→ 指导运营商网络质量的优化</div>
      <div class="wcc-content">→ 手机功能的优化</div>
      <div class="wcc-content"></div>
      <div class="wcc-content">↓↓↓↓↓   APP接入第三方SDK  ↓↓↓↓↓</div>
      <div class="wcc-content">使用SDK名称：腾讯位置服务 定位SDK（从本应用的1.7.X 版本开始使用）</div>
      <div class="wcc-content">第三方名称：深圳市腾讯计算机系统有限公司</div>
      <div class="wcc-content">服务目的：定位服务</div>
      <div class="wcc-content">呈现各种参数，保证测速可靠，判断提速能力是否提供</div>
      <div class="wcc-content">收集/后台收集个人信息类型：</div>
      <div class="wcc-content">→ OAID  目的：处理用户反馈问题和反作弊</div>
      <div class="wcc-content">→ 系统属性   目的：处理不同系统属性的定位策略</div>
      <div class="wcc-content">→ 操作系统及版本  目的：处理不同系统版本的定位策略</div>
      <div class="wcc-content">→ 系统设置  目的：处理用户位置服务开关是否打开的定位策略</div>
      <div class="wcc-content">→ 设备型号   目的：兼容不同手机厂商的定位策略</div>
      <div class="wcc-content">→ 运营商基站信息（Cell id）    目的：向用户提供定位服务</div>
      <div class="wcc-content">→ WIFI信息（WiFi状态、WIFI参数、附近的WIFI列表、连接的WIFI）  目的：向用户提供定位服务</div>
      <div class="wcc-content">→ 传感器信息（重力传感器、陀螺仪传感器 、加速度传感器 、磁场传感器 、旋转矢量传感器 ）   目的：辅助定位功能，在定位丢失时能推导预测定位点。其中旋转矢量传感器 用于获得屏幕朝向 </div>
      <div class="wcc-content">→ 蓝牙信息    目的：向用户提供定位服务</div>
      <div class="wcc-content">→ 设备运动数据   目的：提供了设备姿态数据，用于判断手机在当前空间的位置和姿态</div>
      <div class="wcc-content">→ *精确位置信息（GPS信息）目的：向用户提供定位服务</div>
      <div class="wcc-content">→ BSSID 目的：向用户提供定位服务</div>
      <div class="wcc-content">→ SSID 目的：向用户提供定位服务</div>
      <div class="wcc-content">*需要特别说明的是，我们收集精确位置信息（GPS信息），是为了便于我们帮助您定位您在地图上的位置并为您提供定位服务。上述地位置信息是敏感个人信息，如您拒绝提供，则将无法使用我们的定位服务。</div>
      <div class="wcc-content"></div>
      <div class="wcc-content">使用方式：调用系统相关接口自动采集</div>
      <div class="wcc-content"></div>
      <div class="wcc-content">腾讯位置服务隐私权政策链接：<a href="https://lbs.qq.com/userAgreements/agreements/privacy">https://lbs.qq.com/userAgreements/agreements/privacy</a></div>
      <div class="wcc-content"></div>
      <div class="wcc-content">使用SDK名称：腾讯位置服务 地图SDK（本应用的1.7.X 版本开始使用）</div>
      <div class="wcc-content">第三方名称：深圳市腾讯计算机系统有限公司</div>
      <div class="wcc-content">服务目的：地图服务</div>
      <div class="wcc-content">呈现各种参数，为用户提供可视化页面</div>
      <div class="wcc-content">收集/后台收集个人信息类型：</div>
      <div class="wcc-content">→ OAID  目的：处理用户反馈问题和反作弊</div>
      <div class="wcc-content">→ 网络类型  目的：日志统计、用于维持SDK的运行稳定及定位、修复运营中可能出现的问题</div>
      <div class="wcc-content">→ 设备型号   目的：日志统计、用于维持SDK的运行稳定及定位、修复运营中可能出现的问题</div>
      <div class="wcc-content">→ 手机屏幕密度、尺寸  目的：日志统计、用于维持SDK的运行稳定及定位、修复运营中可能出现的问题</div>
      <div class="wcc-content">→ 操作系统及版本  目的：日志统计、用于维持SDK的运行稳定及定位、修复运营中可能出现的问题</div>
      <div class="wcc-content">→ IP地址    目的：建立socket连接及问题处理</div>
      <div class="wcc-content"></div>
      <div class="wcc-content">使用方式：调用系统相关接口自动采集</div>
      <div class="wcc-content">腾讯位置服务隐私权政策链接：<a href="https://lbs.qq.com/userAgreements/agreements/privacy">https://lbs.qq.com/userAgreements/agreements/privacy</a></div>
      <div class="wcc-content"></div>
      <div class="wcc-content"></div>
      <div class="wcc-content">使用SDK名称：高德开放平台定位SDK（本应用的1.6.4 版本前使用）</div>
      <div class="wcc-content">第三方名称：高德软件有限公司</div>
      <div class="wcc-content">服务目的：地图服务</div>
      <div class="wcc-content">呈现各种参数，保证测速可靠，判断提速能力是否提供</div>
      <div class="wcc-content">收集/后台收集个人信息类型：</div>
      <div class="wcc-content">→ 位置信息（经纬度、精确位置、粗略位置）【通过IP 地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、信号强度的信息、蓝牙信息、传感器信息（矢量、加速度、压力）、设备信号强度信息获取、外部存储目录】、</div>
      <div class="wcc-content">→ 设备标识信息（IMEI、IDFA、IDFV、Android ID、MEID、MAC地址、OAID、IMSI、ICCID、硬件序列号）</div>
      <div class="wcc-content">→ 当前应用信息（应用名、应用版本号）、设备参数及系统信息（系统属性、设备型号、操作系统、运营商信息）。</div>
      <div class="wcc-content">→ 基于不同的设备和系统（安卓/iOS）及系统版本，以及开发者在集成、使用我们SDK产品时决定的权限，收集的设备信息会有所不同，因此开发者应对实际收集的个人信息向用户进行说明。各SDK具体收集使用个人信息情况详见<a href="https://lbs.amap.com/agreement/sample">https://lbs.amap.com/agreement/sample</a>）</div>
      <div class="wcc-content">使用方式：调用系统相关接口自动采集</div>
      <div class="wcc-content"></div>
      <div class="wcc-content">高德隐私权政策链接：<a href="https://lbs.amap.com/pages/privacy/">https://lbs.amap.com/pages/privacy/</a></div>
      <div class="wcc-content"></div>
      <div class="wcc-content">使用SDK名称：极光安全认证SDK</div>
      <div class="wcc-content">第三方名称：深圳市和讯华谷信息技术有限公司</div>
      <div class="wcc-content">服务目的：安全认证服务SDK</div>
      <div class="wcc-content">提高用户体验，取代用户输入手机号码接收短信验证码的方式，帮助用户实现一键登录。</div>
      <div class="wcc-content">收集/后台收集个人信息类型：</div>
      <div class="wcc-content">→ 设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI信息等）：用于检测和防止欺诈活动，检验用户行为是否为机器程序批量自动化操作判断提供相关依据，信息脱敏处理后用来建立异常流量识别模型，实现流量反欺诈技术。</div>
      <div class="wcc-content">→ 网络信息与位置信息（IP地址，WiFi信息，基站信息等相关信息）：优化SDK与极光服务器的网络连接请求，保证服务的稳定性和连续性；信息脱敏处理后用来建立异常、虚拟设备识别模型，实现流量反欺诈技术。</div>
      <div class="wcc-content">→ 用户生物轨迹信息：用户在操作验证过程中所产生的滑动、点击、鼠标移动的轨迹等信息；这些信息脱敏处理后用来建立模拟、暴力、伪造轨迹识别模型，实现流量反欺诈技术。</div>
      <div class="wcc-content">→ APP安装列表信息：我们为向您提供智能认证服务，需要通过该信息识别用户应用环境，帮助你的网站与APP识别与拦截机器程序的批量自动化操作。</div>
      <div class="wcc-content">使用方式：调用系统相关接口自动采集</div>
      <div class="wcc-content">极光隐私权政策链接：<a href="https://www.jiguang.cn/license/privacy">https://www.jiguang.cn/license/privacy</a></div>
      <div class="wcc-content"></div>
      <div class="wcc-content">使用SDK名称：极验;无感本机认证com.geetest(仅限于华为应用市场分发的版本）</div>
      <div class="wcc-content">第三方名称：武汉极意网络科技有限公司</div>
      <div class="wcc-content">服务目的：安全认证服务SDK</div>
      <div class="wcc-content">提高用户体验，取代用户输入手机号码接收短信验证码的方式，帮助用户实现一键登录。</div>
      <div class="wcc-content">收集/后台收集个人信息类型：</div>
      <div class="wcc-content">→极验行为验证服务能够帮助您实时识别异常机器流量，在一定程度上将灰黑产异常流量拦截在业务流程之外，保障业务安全，减少企业损失。为了保障行为验证识别异常流量的准确性，极验在获得您同意和授权情况下，行为验证 SDK 处理和存储一些信息，信息包括但不限于：• 设备信息：设备系统信息、设备厂商信息、设备型号、设备品牌、设备内存大小、设备系统语言等信息；这些信息脱敏处理后用来建立异常流量识别模型，实现流量反欺诈技术。• 设备网络信息：IP、设备联网状态和类型等信息；这些信息脱敏处理后用来建立异常、虚拟设备识别模型，实现流量反欺诈技术。• 设备环境信息：设备屏幕尺寸、设备电池充电状态、设备电量、设备越狱标识、设备调试标识、设备模拟器标识、设备代码篡改标识、浏览器UA、浏览器默认语言、网页请求 referer 等信息；这些信息脱敏处理后用来建立异常、虚拟设备识别模型，实现流量反欺诈技术。• 用户生物轨迹信息：此类信息不是指用户从一个页面跳转到另一个页面所产生的业务跳转轨迹信息，是指用户在操作验证过程中所产生的滑动、点击、鼠标移动的轨迹等信息；这些信息脱敏处理后用来建立模拟、暴力、伪造轨迹识别模型，实现流量反欺诈技术。• 其他信息：验证时间戳、安装包名等信息；这些信息用来建立基础的异常辅助识别模型，实现流量反欺诈技术。</div>
      <div class="wcc-content">→深知Pro业务风控服务能够帮助您实时识别业务风险，并输出当前请求风险分值，辅助企业建立风控系统，风险分值可以作为企业处理异常请求的判断依据。为了保障风险判断的准确性和及时性，极验在获得您同意和授权情况下，深知 Pro SDK 处理和存储一些信息，信息包括但不限于：• 设备信息：设备系统信息、设备厂商信息、设备型号、设备品牌等信息；这些信息脱敏处理后用来建立设备指纹模型，实现安全风控技术。• 设备网络信息：设备联网状态和类型等信息；这些信息脱敏处理后用来建立异常、虚拟设备识别模型，实现安全风控技术。• 设备环境信息：设备屏幕尺寸、设备电池充电状态、设备电量、设备越狱标识、设备调试标识、传感器型号、陀螺仪、处理器等信息；这些信息脱敏处理后用来建立异常、虚拟设备识别模型，实现安全风控技术。• 用户生物轨迹信息：此类信息不是指用户从一个页面跳转到另一个页面所产生的业务跳转轨迹信息，是指用户在业务页面上所产生的滑动、点击、鼠标移动的轨迹等信息；这些信息脱敏处理后用来建立模拟、群控、伪造轨迹识别模型，实现安全风控技术。• 其他信息：请求时间戳、安装包名、系统文件结构、请求头等信息；这些信息用来建立基础的异常辅助识别模型，实现安全风控技术。</div>
      <div class="wcc-content">→行为验是极验可信流量三要素治理解决方案之一，是行为验证的升级版本。以变应万变，七层变化模块应对黑产攻击手段，变换视觉图集模型、变换参数加解密逻辑、变换前端蜜罐策略等对抗思路来提升黑产破解成本，从而保护企业业务安全。• 设备信息：设备系统信息、设备厂商信息、设备型号、设备品牌、OAID等信息；这些信息脱敏处理后用来建立异常流量识别模型，实现流量反欺诈技术。• 设备网络信息：设备联网状态和类型等信息；这些信息脱敏处理后用来建立异常、虚拟设备识别模型，实现流量反欺诈技术。• 设备环境信息：设备屏幕尺寸、设备电池充电状态、设备电量、设备越狱标识、设备调试标识等信息、运营商名称等新信息；这些信息脱敏处理后用来建立异常、虚拟设备识别模型，实现流量反欺诈技术。• 用户生物轨迹信息：此类信息不是指用户从一个页面跳转到另一个页面所产生的业务跳转轨迹信息，是指用户在操作验证过程中所产生的滑动、点击、鼠标移动的轨迹等信息；这些信息脱敏处理后用来建立模拟、暴力、伪造轨迹识别模型，实现流量反欺诈技术• 其他信息：验证时间戳、安装包名等信息；这些信息用来建立基础的异常辅助识别模型，实现流量反欺诈技术。</div>
      <div class="wcc-content">→身份验：服务包括OneLogin、OnePass、一键认证、一键认证（安全版）服务等内容，是我们提供的一款整合三大运营商网关取号及一键登录服务，准确识别用户手机号码，实现App登录注册等环节一键通过，帮助企业优化验证流程，助力运营拉新、留存、促活。• 应用信息：应用名称、应用版本、应用包签名等信息；识别使用应用与报备应用完全一致，避免被使用在未报备的应用中。• 设备信息：设备制造商、设备型号、设备宽高等信息，用于异常流量导致的突发问题被我们及时定位；OAID 信息用于反欺诈风险控制。• 其他信息：手机号、运营商类型、SDK 版本号等信息；支撑产品“一键登录”功能。关于运营商的用户协议和隐私政策，您可在具体使用服务时查看。</div>
      <div class="wcc-content">→设备验是基于设备、账号等信息建立设备指纹、设备标签、流量（账号）标签的风控工具，为企业提供精准唯一设备标识，识别和揭露攻击者的作弊手段和黑产技术；多维度的设备标签能作为企业决策处置的参考信号，提升ROI；在时间序列上循环检测计算的流量标签能够辅助企业建立情报信息，筛查高质量用户。• 设备信息：设备系统、设备型号、设备品牌、设备屏幕尺寸、IMEI、AndroidID、IDFA、IDFV、OAID 和位置信息等；脱敏处理后用来建立设备指纹模型，实现安全风控技术。• 设备环境信息：越狱标识、模拟器标识、调试标识等；这些信息脱敏处理后用来建立异常、虚拟设备识别模型，实现安全风控技术。• 其他信息：手机号、运营商类型、SDK 版本号、安装包名等信息；通过与基础电信运营商或其授权的子公司同步信息比对，进行身份及有效性验证，从而实现风险识别模型的建立。</div>
      <div class="wcc-content">极验隐私权政策链接：<a href="https://www.geetest.com/Private">https://www.geetest.com/Private</a></div>
      <div class="wcc-content"></div>
      <div class="wcc-content">使用SDK名称：BlankjUtilCode工具集</div>
      <div class="wcc-content">服务目的：用于代码工具封装，获取当前日期及app是否在前台</div>
      <div class="wcc-content">官网： <a href="https://github.com/Blankj/AndroidUtilCode">https://github.com/Blankj/AndroidUtilCode</a></div>
      <div class="wcc-content">收集/后台收集个人信息类型：</div>
      <div class="wcc-content">该工具受到APP调用该工具集的IP地址获取的方法，收集IP地址，设备IP地址，在百度提供的IP地址归属地服务上进行查询，以确定用户大致位置（精确到区县级），匹配较近的测速节点服务器。</div>
      <div class="wcc-content"></div>
      <div class="wcc-content">使用SDK名称：测速SDK</div>
      <div class="wcc-content">第三方名称：成都网丁科技有限公司</div>
      <div class="wcc-content">服务目的：进行网络速率测试，得到当前网络的支持的最大速率。其场景包括WIFI网络环境下和移动数据网环境下。</div>
      <div class="wcc-content">测速功能的原理是在服务器和手机之间进行最大速率的数据传输，要求匹配较近的测速服务器。</div>
      <div class="wcc-content">如果不满足手机和服务器较近时，如这个场景：在上海测速，匹配西安的服务器，测速的结果则不可靠。故需要匹配接近的测速节点服务器，以保证测速结果的准确性。</div>
      <div class="wcc-content">收集/后台收集个人信息类型：</div>
      <div class="wcc-content">测速SDK收集IP地址，设备IP地址，在百度提供的IP地址归属地服务上进行查询，以确定用户大致位置（精确到区县级），匹配较近的测速节点服务器。</div>
      <div class="wcc-content">官网：<a href="https://sdk.iwangding.com/new.html">https://sdk.iwangding.com/new.html</a></div>
      <div class="wcc-content">网丁隐私权政策链接：<a href="https://sdk.iwangding.com/yszc.html">https://sdk.iwangding.com/yszc.html</a></div>
      <div class="wcc-content"></div>
      <div class="wcc-content">↑↑↑↑↑     APP接入第三方SDK    ↑↑↑↑↑    </div>
      <div class="wcc-content"></div>
      <div class="wcc-content"></div>
      <div class="wcc-content"></div>
      <div class="wcc-content">2.设备权限调用</div>
      <div class="wcc-content">→ 手机状态：权限名称：android.permission.READ_PHONE_STATE 为了在手机信号工具呈现终端型号、终端系统、接入无线基站小区ID、 网络信息和诊断结果等信息。在WIFI分析工具呈现MAC地址、WIFI网络信息和诊断结果等信息。为了区分和识别用户，我们需要调动您的手机状态权限。</div>
      <div class="wcc-content">→ WIFI状态：权限名称：android.permission.CHANGE_WIFI_MULTICAST_STATE（允许接收 Wi-Fi 多播）在WIFI分析工具呈现WIFI数据</div>
      <div class="wcc-content">→ 存储权限：权限名称：android.permission.WRITE_EXTERNAL_STORAGE 为了存储必要的应用配置文件以及您所选择下载的内容，或读取您需要上传、同步的内容，或者把测试结果以图片的形式存储到手机，需要调用您的存储权限。在 iOS 设备上此权限名为“照片权限”。</div>
      <div class="wcc-content">→ 加速度传感器：为用户呈现海拔高度参数。本参数的需要获取加速度传感器，通过一个算法计算出用户的海拔高度。</div>
      <div class="wcc-content">→ 更改网络连接性：权限名称：android.permission.CHANGE_NETWORK_STATE 在APP功能“网络哪家好”的测试过程中，切换流量测速和WIFI测速，方便用户进行测试。</div>
      <div class="wcc-content">→ ANDROID ID：脱敏地标识出唯一用户。</div>
      <div class="wcc-content">→ 权限名称：android.permission.ACCESS_LOCATION_EXTRA_COMMANDS</div>
      <div class="wcc-content">   位置权限：测速和诊断服务需要获取您的位置信息，以帮助您显示当前所在地区，选择最接近的测速服务器、定位您的网络故障无线基站信息。</div>
      <div class="wcc-content"> 测速功能的原理是在服务器和手机之间进行最大速率的数据传输，要求匹配较近的测速服务器。不满足较近时，例如这个场景：在上海测速，匹配西安的服务器，测速的结果则不可靠。故需要匹配接近的测速节点服务器，以保证测速结果的准确性。</div>
      <div class="wcc-content">→ 在诊断服务中，使用户能够直观的定位故障诊断的地点，并可在地图上调整自己的实际位置，以便能够更加准确定位你附近的无线基站信息。</div>
      <div class="wcc-content">→ 电话权限：在用户查出网络有问题的时候，提供快捷的拨打10000（电信）、10086（移动）、10010（联通）客服热线（自动匹配）的功能。</div>
      <div class="wcc-content">→ 另外网查查调用REQUEST_INSTALL方法，用于本应用的版本升级。</div>
      <div class="wcc-content"></div>
      <div class="wcc-content">您可以随时访问系统“设置”来管理您的系统权限。</div>
      <div class="wcc-content"></div>
      <div class="wcc-content">3. 对未成年人的保护</div>
      <div class="wcc-content">本应用仅供年满18周岁，或达到您所在地区的法定成年年龄的个人使用。如果您未满18周岁，或未达到您所在地区的法定成年年龄，则需要您的法定监护人同意您使用本应用并同意相关应用的服务条款。父母和法定监护人也应采取适当的预防措施来保护未成年人，包括监督其对本应用的使用。</div>
      <div class="wcc-content">如果您未满18周岁，或未达到您所在地区的法定成年年龄，对于经您父母或法定监护人同意而收集您个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息，如果我们发现我们在未事先获得可证实的父母或法定监护人同意的情况下收集了您的个人信息，则会设法尽快删除相关数据。如果您未满18周岁，或未达到您所在地区的法定成年年龄，对于经您父母或法定监护人同意而收集您个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息，如果我们发现我们在未事先获得可证实的父母或法定监护人同意的情况下收集了您的个人信息，则会设法尽快删除相关数据。</div>
      <div class="wcc-content"></div>
      <div class="wcc-content">4. 与第三方共享</div>
      <div class="wcc-content">我们不会与第三方分享您的任何个人信息。我们会将测速或网络信息统计结果共享给电信运营商，用于通信网络质量的改善和手机功能的优化。</div>
      <div class="wcc-content"></div>
      <div class="wcc-content">5. 管理您的数据</div>
      <div class="wcc-content">我们为您设置了便捷方式来管理您的数据。您可以前往系统“设置”关闭“网查查”的“位置信息”、“存储”、“电话”权限，视不同操作系统版本路径有所不同。</div>
      <div class="wcc-content">如您对您的数据主体权利有进一步要求或存在任何疑问、意见或建议，可通过本声明中“如何联系我们”章节中所述方式与我们取得联系，并行使您的相关权利。</div>
      <div class="wcc-content"></div>
      <div class="wcc-content">6. 账号注销</div>
      <div class="wcc-content">账号注销操作是不可恢复的操作。同时，账号注销后，您将无法再登录相应账号使用相关服务，除网查查按照相关法律规定应该保留的相关信息、权益或其他数据外，在您注销账号项下存储、使用等的全部信息、数据等将会被永久删除，请您谨慎进行账号注销操作。此外，账号注销并不代表您在该账号注销前的所有账号行为和相关责任得到豁免或减损。</div>
      <div class="wcc-content">6.1、账号注销的流程</div>
      <div class="wcc-content">如果您需要注销账号，需同时满足以下条件：</div>
      <div class="wcc-content">→ 账号最近1个月内无异常登录、密码修改、密码手机修改等其他影响账户安全的情形；</div>
      <div class="wcc-content">→ 账号内无未完成的订单、服务等；</div>
      <div class="wcc-content">→ 账号没有涉及任何的投诉举报或被投诉举报；</div>
      <div class="wcc-content">→ 账号中无尚未使用的权益，如果您还有尚未使用的权益，注销申请将视为您主动放弃相应权益；</div>
      <div class="wcc-content">→ 不存在任何拖欠或者未缴纳的款项；</div>
      <div class="wcc-content">→ 您在网查查账号下的所有您有权的数据、信息等均已迁出及妥善备份，或您完全放弃保留、找回该等数据的权利；</div>
      <div class="wcc-content">→ 账号注销并未涉及任何已发生的投诉、纠纷、诉讼，主管部门的调查等，以及不存在上述涉诉、被调整的现实性风险；</div>
      <div class="wcc-content">→ 账号不存在其他依照法律法规的要求应当履行而尚未履行的义务等情形；</div>
      <div class="wcc-content">网查查在核查过程中，如果发现您账号不能同时满足上述条件的，您的账号注销申请将被驳回。如果您希望继续注销，需根据驳回原因处理完成相关事项后，重新发起账号注销申请。</div>
      <div class="wcc-content">6.2、账号注销的后果</div>
      <div class="wcc-content">您知悉并同意，账号完成注销流程后将产生包括但不限于以下后果：</div>
      <div class="wcc-content">→ 您将无法依赖于该账号进行任何权限操作；</div>
      <div class="wcc-content">→ 您原先拥有的账号将被收回，您无权再使用原有的账号。</div>
      <div class="wcc-content">→ 您将无法找回该账号下您曾经存储、使用等的全部信息、数据等，研究院按照相关法律规定应该保留的相关信息或数据除外。</div>
      <div class="wcc-content">→ 其他可能对您的权益造成损害或给您造成损失的后果。</div>
      <div class="wcc-content">6.3、账号注销的方法</div>
      <div class="wcc-content">在APP内点击“我的”点击“账号注销”同意“注销须知”后，点击“立刻注销”即可。</div>
      <div class="wcc-content"></div>
      <div class="wcc-content">7. 数据存储地点及期限</div>
      <div class="wcc-content">本应用收集的个人信息将会传输并保存至中华人民共和国境内的服务器。</div>
      <div class="wcc-content">我们保留以下目的相关的历史性数据：进行分析和准备产品增强，准备市场报告，并将测速结果共享给电信运营商，用于通信网络质量的改善和手机功能的优化。</div>
      <div class="wcc-content">此外，当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。</div>
      <div class="wcc-content"></div>
      <div class="wcc-content">8. 如何联系我们</div>
      <div class="wcc-content"></div>
      <div class="wcc-content">我们设立了个人信息保护专职部门（或个人信息保护专员），您可以通过访问隐私问题与其取得联系，致电023-86763377。</div>
      <div class="wcc-content">如果您对我们的回复不满意，特别是当我们的个人信息处理行为损害了您的合法权益时，您还可以通过向有管辖权的人民法院提起诉讼、向行业自律协会或政府相关管理机构投诉等外部途径进行解决。您也可以向我们了解可能适用的相关投诉途径的信息。</div>
      <div class="wcc-content">本公司将始终遵照我们的隐私政策来收集和使用您的信息。</div>

    </div>

  </div>
</template>

<script>
export default {
  data: function () {
    return {}
  },
  methods: {
    goBack: function () {
      if (window.JSInterface) {
        window.JSInterface.callMethod('close', null)
      } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.JSInterface) {
        window.webkit.messageHandlers.JSInterface.postMessage("{\"method\":\"close\"}");
      }
    },
  }
}
</script>

<style>
.wcc-header-1 {
  text-align: center;
  font-size: 1.2em;
  line-height: 2em;
  font-weight: bold;
  margin-bottom: 10px;
}

.wcc-header-2 {
  font-size: 1.1em;
  line-height: 2em;
  font-weight: bold;
}

.wcc-content {
  text-indent: 2em;
  margin-bottom: 10px;
}
</style>
